import { c as _c } from "react/compiler-runtime";
import { HStack, Icon, Text } from '@chakra-ui/react';
import { attachmentCountLabel } from '@src/components/sco/Admin/AiCrm/crmAttachments';
import React from 'react';
import { LuPaperclip } from 'react-icons/lu';

/**
 * The paperclip line under a message preview in a list: the files are on the message, and a message that
 * is only a file has no text to show. The files themselves open in the conversation. Nothing for none.
 */
export function CrmAttachmentHint(props) {
  const $ = _c(8);
  let t0;
  if ($[0] !== props.count) {
    t0 = attachmentCountLabel(props.count);
    $[0] = props.count;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const label = t0;
  if (!label) {
    return null;
  }
  const t1 = props.mt ?? 1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Icon boxSize={3}><LuPaperclip /></Icon>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== label) {
    t3 = <Text fontSize="xs">{label}</Text>;
    $[3] = label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <HStack color="fg.subtle" gap={1} mt={t1}>{t2}{t3}</HStack>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}